export default __webpack_public_path__ + "static/media/services_municipal_4.f9f68e13.jpg";